import React, { Component } from 'react';
import Formulario from './subProyectosForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class SubProyectos extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, listarProyectos, getModulo } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        listarProyectos();
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
    }
    
    render(){
        const { registroSubProyecto, modificarSubProyecto, loader, listaProyectos, lectura, modulo } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroSubProyecto : modificarSubProyecto;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    obtenerProyectos = {listaProyectos}
                    onSubmit = {funcionEnvio}
                    crear = {crear}
                    lectura={lectura}
                    modulo = {modulo}
                />
            </LoadMask>
        );
    }
}

export default SubProyectos;
